'use client';

import type { Product } from 'generated/graphql';
import { create } from 'zustand';

interface Store {
  product?: Product | null;
  dirty: boolean;
  setDirty: (dirty: boolean) => void;
  allowClose: boolean;
  setAllowClose: (allowClose: boolean) => void;
  openProductSettings: boolean;
  onOpenProductSettings: (product: Product) => void;
  onCloseProductSettings: () => void;
}

export const useProductSettingsStore = create<Store>((set) => ({
  product: null,
  dirty: false,
  setDirty: (dirty) => set({ dirty }),
  allowClose: true,
  setAllowClose: (allowClose) => set({ allowClose }),
  openProductSettings: false,
  onOpenProductSettings: (product) => set({ product, openProductSettings: true }),
  onCloseProductSettings: () => set({ openProductSettings: false }),
}));
